module.exports = __webpack_public_path__ + "media/video.f8e4f3e3.mp4";